module.exports = __webpack_public_path__ + "media/images/icons/smp_security-64f118f6e296015d1cb383398a3a4cee.svg";